<div class="modal-overlay" *ngIf="isOpen" role="dialog" aria-modal="true" (click)="onClose()">
  <div class="modal-dialog" data-testid="venda-balcao-modal" (click)="$event.stopPropagation()">
    <div class="modal-content">

      <div class="modal-header">
        <h2 class="modal-title d-flex align-items-center">
          <i class="bi bi-cash-coin me-2"></i> Venda Balcão
        </h2>
        <button type="button" class="btn-close" data-testid="btn-fechar-venda-balcao" (click)="onClose()" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <p class="text-muted mb-3">Registre uma venda simples de forma rápida.</p>

        <form [formGroup]="form" (ngSubmit)="salvar()" id="vendaBalcaoForm">

          <!-- Vendedor -->
          <div class="form-section">
            <h3>Vendedor</h3>
            <div class="row g-3">
              <div class="col-md-4">
                <label for="codigoVendedor" class="form-label">Código do Vendedor</label>
                <div class="input-group">
                  <input
                    type="number"
                    id="codigoVendedor"
                    class="form-control"
                    [class.is-invalid]="form.get('codigoVendedor')?.touched && form.get('codigoVendedor')?.invalid"
                    formControlName="codigoVendedor"
                    placeholder="Ex.: 1"
                    (keyup.enter)="buscarVendedor()">
                  <button type="button" class="btn btn-outline-secondary" data-testid="btn-buscar-vendedor" (click)="buscarVendedor()">Buscar</button>
                </div>
                <div *ngIf="form.get('codigoVendedor')?.touched && form.get('codigoVendedor')?.errors?.['notFound']" class="invalid-feedback d-block">
                  Vendedor não encontrado.
                </div>
                <div *ngIf="form.get('codigoVendedor')?.touched && form.get('codigoVendedor')?.errors?.['inativo']" class="invalid-feedback d-block">
                  Vendedor inativo.
                </div>
                <div *ngIf="form.get('codigoVendedor')?.touched && form.get('codigoVendedor')?.errors?.['required']" class="invalid-feedback d-block">
                  Informe o código do vendedor.
                </div>
              </div>
              <div class="col-md-8">
                <label class="form-label">Nome do Vendedor</label>
                <input type="text" class="form-control readonly-field" [value]="nomeVendedor" readonly placeholder="Preenchido após busca">
              </div>
            </div>
          </div>

          <!-- Cliente -->
          <div class="form-section">
            <h3>Cliente</h3>
            <div class="row g-3">
              <div class="col-md-4">
                <label for="codigoCliente" class="form-label">Código do Cliente</label>
                <div class="input-group">
                  <input
                    type="number"
                    id="codigoCliente"
                    class="form-control"
                    [class.is-invalid]="form.get('codigoCliente')?.touched && form.get('codigoCliente')?.invalid"
                    formControlName="codigoCliente"
                    placeholder="Ex.: 1"
                    (keyup.enter)="buscarCliente()">
                  <button type="button" class="btn btn-outline-secondary" data-testid="btn-buscar-cliente" (click)="buscarCliente()">Buscar</button>
                </div>
                <div *ngIf="form.get('codigoCliente')?.touched && form.get('codigoCliente')?.errors?.['notFound']" class="invalid-feedback d-block">
                  Cliente não encontrado.
                </div>
                <div *ngIf="form.get('codigoCliente')?.touched && form.get('codigoCliente')?.errors?.['required']" class="invalid-feedback d-block">
                  Informe o código do cliente.
                </div>
              </div>
              <div class="col-md-5">
                <label class="form-label">Nome do Cliente</label>
                <input type="text" class="form-control readonly-field" [value]="nomeCliente" readonly placeholder="Preenchido após busca ou seleção">
              </div>
              <div class="col-md-3 d-flex align-items-end">
                <button type="button" class="btn btn-outline-primary w-100" data-testid="btn-selecionar-cliente" (click)="abrirClienteModal()">
                  Selecionar
                </button>
              </div>
            </div>
          </div>

          <!-- Valores -->
          <div class="form-section">
            <h3>Valores</h3>
            <div class="row g-3">
              <div class="col-md-4">
                <label for="subtotal" class="form-label">Subtotal (R$)</label>
                <input
                  type="number"
                  id="subtotal"
                  class="form-control"
                  [class.is-invalid]="form.get('subtotal')?.touched && form.get('subtotal')?.invalid"
                  formControlName="subtotal"
                  placeholder="0,00"
                  min="0.01"
                  step="0.01">
                <div *ngIf="form.get('subtotal')?.touched && form.get('subtotal')?.invalid" class="invalid-feedback">
                  Informe um subtotal maior que zero.
                </div>
              </div>
              <div class="col-md-4">
                <label for="descontoAplicado" class="form-label">Desconto (R$)</label>
                <input
                  type="number"
                  id="descontoAplicado"
                  class="form-control"
                  [class.is-invalid]="descontoInvalido && form.get('descontoAplicado')?.touched"
                  formControlName="descontoAplicado"
                  placeholder="0,00"
                  min="0"
                  step="0.01">
                <div *ngIf="descontoInvalido && form.get('descontoAplicado')?.touched" class="invalid-feedback d-block">
                  Desconto não pode ser maior que o subtotal.
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">Valor Total (R$)</label>
                <input
                  type="text"
                  class="form-control readonly-field"
                  [value]="valorTotal | currency:'BRL'"
                  readonly>
                <small class="field-helper">Calculado automaticamente: Subtotal - Desconto</small>
                <small class="field-helper" data-testid="faixa-venda-balcao" *ngIf="limitesCarregados && (limiteMinimo !== null || limiteMaximo !== null)">
                  Faixa permitida para venda balcão:
                  <ng-container *ngIf="limiteMinimo !== null">de <span data-testid="limite-minimo-balcao">{{ limiteMinimo | currency:'BRL' }}</span></ng-container>
                  <ng-container *ngIf="limiteMaximo !== null"> até <span data-testid="limite-maximo-balcao">{{ limiteMaximo | currency:'BRL' }}</span></ng-container>
                </small>
              </div>
            </div>
          </div>

          <!-- Observação -->
          <div class="form-section">
            <h3>Observações</h3>
            <div class="row g-3">
              <div class="col-12">
                <label for="observacao" class="form-label">Observação <span class="text-danger">*</span></label>
                <textarea
                  class="form-control"
                  id="observacao"
                  formControlName="observacao"
                  rows="3"
                  [class.is-invalid]="form.get('observacao')?.touched && form.get('observacao')?.invalid"
                  placeholder="Informações adicionais sobre a venda (mínimo 15 caracteres)..."></textarea>
                <div *ngIf="form.get('observacao')?.touched && form.get('observacao')?.errors?.['required']" class="invalid-feedback d-block">
                  Informe a observação da venda.
                </div>
                <div *ngIf="form.get('observacao')?.touched && form.get('observacao')?.errors?.['minlength']" class="invalid-feedback d-block">
                  A observação deve ter pelo menos 15 caracteres ({{ form.get('observacao')?.value?.trim()?.length || 0 }}/15).
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-testid="btn-cancelar-venda-balcao" (click)="onClose()" [disabled]="isLoading">Cancelar</button>
        <button type="submit" form="vendaBalcaoForm" class="btn btn-primary" data-testid="btn-confirmar-venda-balcao" [disabled]="isLoading">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
          {{ isLoading ? 'Processando...' : 'Confirmar Venda' }}
        </button>
      </div>

    </div>
  </div>
</div>

<!-- Modais internos: mantidos após o overlay para pintarem acima dele -->
<app-cliente-modal
  [isOpen]="isClienteModalOpen"
  (closeModal)="closeClienteModal($event)">
</app-cliente-modal>

<app-venda-modal-v2
  *ngIf="orcamentoCriado"
  [isOpen]="isVendaModalOpen"
  [orcamento]="orcamentoCriado"
  [tipoAcao]="'NOVA_VENDA'"
  [clienteComRestricao]="clienteRestricaoAtiva"
  (vendaEfetuada)="onVendaEfetuada($event)"
  (closeModal)="closeVendaModal($event)">
</app-venda-modal-v2>

<!-- Cupom não fiscal: exibido após a venda ser concluída -->
<div class="modal-overlay" *ngIf="isCupomOpen && cupom as c" role="dialog" aria-modal="true" data-testid="cupom-overlay">
  <div class="modal-dialog cupom-dialog" data-testid="cupom-modal" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title d-flex align-items-center">
          <i class="bi bi-receipt me-2"></i> Cupom da Venda
        </h2>
      </div>
      <div class="modal-body">
        <div class="cupom-papel" data-testid="cupom-papel">
          <div class="cupom-empresa" data-testid="cupom-empresa" *ngIf="c.empresa as emp">
            <div class="cupom-empresa__fantasia" data-testid="cupom-empresa-fantasia" *ngIf="emp.nomeFantasia?.trim()">{{ emp.nomeFantasia }}</div>
            <div data-testid="cupom-empresa-razao" *ngIf="emp.razaoSocial?.trim()">{{ emp.razaoSocial }}</div>
            <div data-testid="cupom-empresa-cnpj" *ngIf="emp.cnpj?.trim()">CNPJ {{ formatarCnpj(emp.cnpj) }}</div>
            <div data-testid="cupom-empresa-ie" *ngIf="emp.inscricaoEstadual?.trim()">IE {{ emp.inscricaoEstadual!.trim() }}</div>
            <div data-testid="cupom-empresa-endereco" *ngIf="montarEnderecoEmpresa(emp) as end">{{ end }}</div>
            <div data-testid="cupom-empresa-telefone" *ngIf="emp.telefone?.trim()">{{ formatarTelefone(emp.telefone) }}</div>
            <div data-testid="cupom-empresa-email" *ngIf="emp.email?.trim()">{{ emp.email }}</div>
          </div>
          <div class="cupom-aviso" data-testid="cupom-aviso-nao-fiscal">DOCUMENTO NÃO FISCAL<br>SEM VALOR FISCAL</div>
          <div class="cupom-centro">Comprovante de Venda Balcão</div>
          <hr>
          <div class="cupom-linha"><span>Referência</span><span>#{{ c.numeroReferencia }}</span></div>
          <div class="cupom-linha"><span>Emissão</span><span>{{ formatarDataHora(c.emitidoEm) }}</span></div>
          <div class="cupom-linha"><span>Vendedor</span><span>{{ c.nomeVendedor }}</span></div>
          <hr>
          <div>Cliente: {{ c.nomeCliente }}</div>
          <div *ngIf="c.cpfCnpjCliente">CPF/CNPJ: {{ c.cpfCnpjCliente }}</div>
          <hr>
          <div class="cupom-linha"><span>Subtotal</span><span>{{ c.subtotal | currency:'BRL' }}</span></div>
          <div class="cupom-linha"><span>Desconto</span><span>- {{ c.desconto | currency:'BRL' }}</span></div>
          <div class="cupom-linha cupom-total"><span>TOTAL</span><span>{{ c.valorTotal | currency:'BRL' }}</span></div>
          <hr>
          <div class="cupom-linha"><span>Tipo</span><span>{{ c.tipoVenda }}</span></div>
          <div class="cupom-linha"><span>Forma</span><span>{{ c.formaPagamento }}</span></div>
          <div class="cupom-linha" *ngIf="c.bandeira"><span>Bandeira</span><span>{{ c.bandeira }}</span></div>
          <div class="cupom-linha" *ngIf="c.numParcelas > 1"><span>Parcelas</span><span>{{ c.numParcelas }}x</span></div>
          <div class="cupom-linha" *ngIf="c.valorEntrada"><span>Entrada</span><span>{{ c.valorEntrada | currency:'BRL' }}</span></div>
          <div class="cupom-linha" *ngIf="c.previsaoEntrega"><span>Previsão entrega</span><span>{{ formatarData(c.previsaoEntrega) }}</span></div>
          <hr>
          <div>Observação:</div>
          <div class="cupom-obs">{{ c.observacao }}</div>
          <hr>
          <div class="cupom-aviso">ESTE DOCUMENTO NÃO É UM CUPOM FISCAL</div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-testid="btn-sair-cupom" (click)="fecharCupom()">Sair</button>
        <button type="button" class="btn btn-primary" data-testid="btn-imprimir-cupom" (click)="imprimirCupom()">
          <i class="bi bi-printer me-1"></i> Imprimir
        </button>
      </div>
    </div>
  </div>
</div>
